import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

const _hoisted_1 = ["lang"]
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = { "aria-current": "page" }
const _hoisted_4 = { class: "guide-lead" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = { class: "guide-access-note" }
const _hoisted_7 = { href: "#guide-play" }
const _hoisted_8 = { class: "guide-toc" }
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = { href: "#guide-comparison" }
const _hoisted_11 = ["href"]
const _hoisted_12 = { href: "#guide-play" }
const _hoisted_13 = { href: "#variant-title" }
const _hoisted_14 = {
  id: "guide-comparison",
  class: "guide-comparison",
  "aria-labelledby": "guide-comparison-title"
}
const _hoisted_15 = { id: "guide-comparison-title" }
const _hoisted_16 = ["aria-label"]
const _hoisted_17 = { scope: "row" }
const _hoisted_18 = ["href"]
const _hoisted_19 = { class: "guide-cards" }
const _hoisted_20 = ["aria-labelledby"]
const _hoisted_21 = ["id"]
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  key: 0,
  class: "guide-preview"
}
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = ["aria-labelledby"]
const _hoisted_26 = ["id"]
const _hoisted_27 = {
  key: 0,
  class: "guide-source"
}
const _hoisted_28 = ["href"]
const _hoisted_29 = {
  id: "guide-play",
  class: "wiki-panel guide-setup",
  "aria-labelledby": "setup-title"
}
const _hoisted_30 = { id: "setup-title" }
const _hoisted_31 = { "aria-labelledby": "human-setup-title" }
const _hoisted_32 = { id: "human-setup-title" }
const _hoisted_33 = { "aria-labelledby": "ai-setup-title" }
const _hoisted_34 = { id: "ai-setup-title" }
const _hoisted_35 = { class: "guide-start-steps" }
const _hoisted_36 = {
  class: "wiki-panel guide-variant",
  "aria-labelledby": "variant-title"
}
const _hoisted_37 = { id: "variant-title" }
const _hoisted_38 = {
  class: "guide-prose",
  "aria-labelledby": "next-title"
}
const _hoisted_39 = { id: "next-title" }
const _hoisted_40 = ["aria-label"]
const _hoisted_41 = ["aria-label"]
const _hoisted_42 = { class: "guide-source" }

import { computed, onMounted, watch } from 'vue';
import { RouterLink, useRoute } from 'vue-router';
import type { TLanguage } from '@/i18n/interface';
import { localizedPath } from '@/router/paths';
import { getGuideLocale } from './locales';
import { trackGuideVisit, trackGuideCta } from '@/helpers/acquisition';
import { getImagePathByID } from '@/helpers/images';
import type { GuideId } from './content';


export default /*@__PURE__*/_defineComponent({
  __name: 'Guide',
  props: {
    guide: {}
  },
  setup(__props: any) {

const props = __props;
const route = useRoute();
const language = computed(() => (route.meta.lang || 'en') as TLanguage);
const collection = computed(() => getGuideLocale(language.value));
const copy = computed(() => collection.value.copy);
const page = computed(() => collection.value.guides[props.guide]);
const path = (pathname: string) => localizedPath(pathname, language.value);
const related = computed(() =>
  Object.entries(collection.value.guides)
    .filter(([id]) => id !== props.guide)
    .map(([, guide]) => guide),
);
const preview = getImagePathByID('other', 'preview');
let mounted = false;
onMounted(() => {
  mounted = true;
  trackGuideVisit(page.value.slug, language.value);
});
watch([() => props.guide, language], () => {
  if (mounted) trackGuideVisit(page.value.slug, language.value);
});

function trackCta(event: MouseEvent, destination: 'lobby' | 'community' | 'ai') {
  if (event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
    trackGuideCta(page.value.slug, destination, language.value);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", {
    class: "info-page-content wiki-page guide-page",
    lang: language.value
  }, [
    _createElementVNode("nav", {
      class: "guide-breadcrumbs",
      "aria-label": copy.value.breadcrumbLabel
    }, [
      _createVNode(_unref(RouterLink), {
        to: path('/')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(copy.value.home), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _cache[7] || (_cache[7] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1)),
      (_ctx.guide !== 'social_deduction_games_online')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_unref(RouterLink), {
              to: path('/guides/social-deduction-games-online/')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(collection.value.guides.social_deduction_games_online.breadcrumb), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _cache[6] || (_cache[6] = _createElementVNode("span", { "aria-hidden": "true" }, "/", -1))
          ], 64))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_3, _toDisplayString(page.value.breadcrumb), 1)
    ], 8, _hoisted_2),
    _createElementVNode("h1", null, _toDisplayString(page.value.title), 1),
    _createElementVNode("p", _hoisted_4, _toDisplayString(page.value.lead), 1),
    _createElementVNode("nav", {
      class: "wiki-nav guide-actions",
      "aria-label": copy.value.startLabel
    }, [
      _createVNode(_unref(RouterLink), {
        class: "primary-cta",
        to: { path: path('/'), hash: '#play-with-ai' },
        onClick: _cache[0] || (_cache[0] = ($event: any) => (trackCta($event, 'ai')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(copy.value.aiCta), 1)
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_unref(RouterLink), {
        to: path('/'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (trackCta($event, 'lobby')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(copy.value.lobbyCta), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ], 8, _hoisted_5),
    _createElementVNode("p", _hoisted_6, [
      _createTextVNode(_toDisplayString(copy.value.aiAccessNote) + " ", 1),
      _createElementVNode("a", _hoisted_7, _toDisplayString(copy.value.setupLabel), 1)
    ]),
    _createElementVNode("details", _hoisted_8, [
      _createElementVNode("summary", null, _toDisplayString(copy.value.tocTitle), 1),
      _createElementVNode("nav", {
        "aria-label": copy.value.tocTitle
      }, [
        _createElementVNode("ul", null, [
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_10, _toDisplayString(copy.value.comparisonLabel), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.sections, (section, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: section.title
            }, [
              _createElementVNode("a", {
                href: `#guide-section-${index}`
              }, _toDisplayString(section.title), 9, _hoisted_11)
            ]))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_12, _toDisplayString(copy.value.setupLabel), 1)
          ]),
          _createElementVNode("li", null, [
            _createElementVNode("a", _hoisted_13, _toDisplayString(copy.value.variantTitle), 1)
          ])
        ])
      ], 8, _hoisted_9)
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createElementVNode("h2", _hoisted_15, _toDisplayString(page.value.table.caption), 1),
      _createElementVNode("div", {
        class: "guide-table",
        role: "region",
        "aria-label": page.value.table.caption,
        tabindex: "0"
      }, [
        _createElementVNode("table", null, [
          _createElementVNode("caption", null, _toDisplayString(page.value.table.caption), 1),
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.table.columns, (column) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: column,
                  scope: "col"
                }, _toDisplayString(column), 1))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.table.rows, (row) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: row.title
              }, [
                _createElementVNode("th", _hoisted_17, [
                  _createTextVNode(_toDisplayString(row.title) + " ", 1),
                  (row.source)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        class: "source-link",
                        href: row.source.url
                      }, _toDisplayString(row.source.label), 9, _hoisted_18))
                    : _createCommentVNode("", true)
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, index) => {
                  return (_openBlock(), _createElementBlock("td", { key: index }, _toDisplayString(cell), 1))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ], 8, _hoisted_16),
      _createElementVNode("div", _hoisted_19, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.table.rows, (row, rowIndex) => {
          return (_openBlock(), _createElementBlock("section", {
            key: row.title,
            class: "guide-card",
            "aria-labelledby": `comparison-row-${rowIndex}`
          }, [
            _createElementVNode("h3", {
              id: `comparison-row-${rowIndex}`
            }, _toDisplayString(row.title), 9, _hoisted_21),
            _createElementVNode("dl", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.cells, (cell, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("dt", null, _toDisplayString(page.value.table.columns[index + 1]), 1),
                  _createElementVNode("dd", null, _toDisplayString(cell), 1)
                ], 64))
              }), 128))
            ]),
            (row.source)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "source-link",
                  href: row.source.url
                }, _toDisplayString(row.source.label), 9, _hoisted_22))
              : _createCommentVNode("", true)
          ], 8, _hoisted_20))
        }), 128))
      ])
    ]),
    (page.value.preview)
      ? (_openBlock(), _createElementBlock("figure", _hoisted_23, [
          _createElementVNode("img", {
            src: _unref(preview),
            alt: copy.value.previewAlt,
            width: "1250",
            height: "1250",
            loading: "lazy"
          }, null, 8, _hoisted_24),
          _createElementVNode("figcaption", null, _toDisplayString(copy.value.previewCaption), 1)
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(page.value.sections, (section, index) => {
      return (_openBlock(), _createElementBlock("section", {
        class: "guide-prose",
        key: section.title,
        "aria-labelledby": `guide-section-${index}`
      }, [
        _createElementVNode("h2", {
          id: `guide-section-${index}`
        }, _toDisplayString(section.title), 9, _hoisted_26),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
          return (_openBlock(), _createElementBlock("p", { key: paragraph }, _toDisplayString(paragraph), 1))
        }), 128)),
        (section.source)
          ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
              _createTextVNode(_toDisplayString(copy.value.sourceLabel) + ": ", 1),
              _createElementVNode("a", {
                href: section.source.url
              }, _toDisplayString(section.source.label), 9, _hoisted_28),
              _cache[8] || (_cache[8] = _createTextVNode(". "))
            ]))
          : _createCommentVNode("", true)
      ], 8, _hoisted_25))
    }), 128)),
    _createElementVNode("aside", _hoisted_29, [
      _createElementVNode("h2", _hoisted_30, _toDisplayString(copy.value.setupTitle), 1),
      _createElementVNode("section", _hoisted_31, [
        _createElementVNode("h3", _hoisted_32, _toDisplayString(copy.value.humanTitle), 1),
        _createElementVNode("dl", null, [
          _createElementVNode("div", null, [
            _createElementVNode("dt", null, _toDisplayString(copy.value.playersLabel), 1),
            _createElementVNode("dd", null, _toDisplayString(copy.value.humanPlayers), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("dt", null, _toDisplayString(copy.value.accessLabel), 1),
            _createElementVNode("dd", null, _toDisplayString(copy.value.humanAccess), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("dt", null, _toDisplayString(copy.value.discussionLabel), 1),
            _createElementVNode("dd", null, _toDisplayString(copy.value.humanDiscussion), 1)
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("dt", null, _toDisplayString(copy.value.findingGroupLabel), 1),
            _createElementVNode("dd", null, _toDisplayString(copy.value.findingGroup), 1)
          ])
        ]),
        _createElementVNode("p", null, _toDisplayString(copy.value.boardsNote), 1)
      ]),
      _createElementVNode("section", _hoisted_33, [
        _createElementVNode("h3", _hoisted_34, _toDisplayString(copy.value.aiTitle), 1),
        _createElementVNode("p", null, _toDisplayString(copy.value.aiIntro), 1),
        _createElementVNode("p", null, _toDisplayString(copy.value.aiAvailability), 1)
      ]),
      _createElementVNode("details", _hoisted_35, [
        _createElementVNode("summary", null, _toDisplayString(copy.value.setupLabel), 1),
        _createElementVNode("p", null, _toDisplayString(copy.value.nextAi), 1),
        _createElementVNode("p", null, _toDisplayString(copy.value.nextHuman), 1)
      ])
    ]),
    _createElementVNode("aside", _hoisted_36, [
      _createElementVNode("h2", _hoisted_37, _toDisplayString(copy.value.variantTitle), 1),
      _createElementVNode("p", null, _toDisplayString(copy.value.proposalVariant), 1),
      _createElementVNode("p", null, _toDisplayString(copy.value.assassinationVariant), 1),
      _createVNode(_unref(RouterLink), {
        to: path('/wiki/rules/')
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(copy.value.fullRulesCta), 1)
        ]),
        _: 1
      }, 8, ["to"])
    ]),
    _createElementVNode("section", _hoisted_38, [
      _createElementVNode("h2", _hoisted_39, _toDisplayString(copy.value.nextTitle), 1),
      _createElementVNode("nav", {
        class: "wiki-nav",
        "aria-label": copy.value.arrangeLabel
      }, [
        _createVNode(_unref(RouterLink), {
          class: "primary-cta",
          to: { path: path('/'), hash: '#play-with-ai' },
          onClick: _cache[2] || (_cache[2] = ($event: any) => (trackCta($event, 'ai')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.aiCta), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), {
          to: path('/'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (trackCta($event, 'lobby')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.lobbyCta), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), {
          to: path('/community/groups/'),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (trackCta($event, 'community')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.browseGroupsCta), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), {
          to: path('/community/players/'),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (trackCta($event, 'community')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.findPlayersCta), 1)
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_unref(RouterLink), {
          to: path('/wiki/roles/merlin/')
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(copy.value.merlinCta), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ], 8, _hoisted_40)
    ]),
    _createElementVNode("nav", {
      class: "guide-related",
      "aria-label": copy.value.relatedLabel
    }, [
      _createElementVNode("h2", null, _toDisplayString(copy.value.relatedTitle), 1),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(related.value, (other) => {
          return (_openBlock(), _createElementBlock("li", {
            key: other.slug
          }, [
            _createVNode(_unref(RouterLink), {
              to: path(`/guides/${other.slug}/`)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(other.title), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]))
        }), 128))
      ])
    ], 8, _hoisted_41),
    _createElementVNode("p", _hoisted_42, _toDisplayString(copy.value.ownership), 1)
  ], 8, _hoisted_1))
}
}

})